import * as Sentry from "@client/telemetry/sentry";

export function captureExceptionWithPriority(error: Error): void {
  if (error.message.startsWith("Not permitted (")) {
    Sentry.withScope((scope) => {
      scope.setLevel("warning");
      scope.setTag("error_priority", "low");
      scope.setTag("error_category", "permission");
      Sentry.captureException(error);
    });
    return;
  }

  Sentry.captureException(error);
}
